import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import Header from 'components/Headers/Header';
import AllSpecialtiesSubscriptionStatus from 'components/Billing/AllSpecialtiesSubscriptionStatus';
import TrialManagementCard from 'components/Billing/TrialManagementCard';
import PaymentMethodsCard from 'components/Billing/PaymentMethodsCard';
import BillingHistoryCard from 'components/Billing/BillingHistoryCard';
import { listPaymentMethods } from 'redux/Billing/BillingActions';
import { fetchPaymentRecord } from 'redux/Payments/PaymentsActions';

const BillingPage = ({ userHandle }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listPaymentMethods()).catch(() => { /* handled */ });
        if (userHandle) {
            dispatch(fetchPaymentRecord({ table: 'subscriptions', user: userHandle }));
        }
    }, [dispatch, userHandle]);

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <Row>
                    <Col xl="12" className="mt-3">
                        <AllSpecialtiesSubscriptionStatus />
                    </Col>
                    <Col xl="12" className="mt-3">
                        <TrialManagementCard />
                    </Col>
                    <Col xl="12" className="mt-3">
                        <PaymentMethodsCard />
                    </Col>
                    <Col xl="12" className="mt-3 mb-4">
                        <BillingHistoryCard />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const mapStateToProps = state => ({
    userHandle: state.loginAuth.userDetails?.handle,
});

export default connect(mapStateToProps)(BillingPage);
